<template>
  <div>
    <img
      v-if="OnChangeImg"
      :src="ChangeImgUrl"
      class="custom-image"
      @click="showFileChooser"
    />
    <div v-else>
      <button type="button" @click="showFileChooser" class="btn btn-upload">
        Select image
      </button>
    </div>

    <!--    <div class='group-button-image'>-->
<!--      <img-->
<!--        v-if="OnChangeImg"-->
<!--        :src="ChangeImgUrl"-->
<!--        class="custom-image"-->
<!--        @click="showFileChooser"-->
<!--      />-->

<!--      <div v-if="OnChangeImg">-->
<!--        <button type="button" @click="showFileChooser" class="btn btn-upload-new">-->
<!--          <v-icon class='v-ion-abn' name='upload-cloud'></v-icon> Choose an image-->
<!--        </button>-->
<!--      </div>-->

<!--      <div v-else>-->
<!--        <button type="button" @click="showFileChooser" class="btn btn-upload-new">-->
<!--          <v-icon class='v-ion-abn' name='upload-cloud'></v-icon> Choose an image-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
    <v-dialog />
    <modal
      :name="modalName"
      :adaptive="true"
      height="auto"
      width="1000"
      @ok="onCrop"
      @cancel="handleCancel"
      :clickToClose="false"
      :reset="true"
      class='Modal_crop_box'
    >
      <div @click="hideModal" class="Abn-modal-close">&#10005;</div>
      <div class='Abn-modal-crop'>
      <div class="modal-wrapper">
        <div class="cropper-wrapper">
          <vue-cropper
            v-if="imgData"
            ref="cropper"
            :aspect-ratio="aspectRatio"
            :src="imgData"
            :zoom="zoom"
          />
        </div>

      </div>
      </div>

       <div class="Abn-modal-footer">
          <div class="Abn-modal-footer-div">
             <button class="btn Abn-btn-cancel" @click="hideModal">Cancel</button>
            <button  class="btn Abn-btn-apply" @click="onCrop" :disabled="loading">
              <font-awesome-icon v-if="loading" icon="spinner" class="fa-spin" />
              OK
            </button>
          </div>
        </div>


    </modal>
    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />
  </div>
</template>
<script>
import { get } from 'lodash'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import axios from 'axios'
import { ASSET_URL } from '@/config.js'
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    }
  },
  components: {
    VueCropper
  },
  data() {
    return {
      file: null,
      imgData: null,
      cropData: null,
      showCropper: false,
      loading: false,
      messageLoading: false,
      OnChangeImg: false,
      ChangeImgUrl: null,
      imgObjectUrl: null,
      maxImageDimension: 2500
    }
  },
  watch: {
    context(value){
      const key = get(value, 'model.key', null);
      if(key && this.isSaveLocalstorage() && (key.indexOf('upload-custom') >= 0 || key.indexOf('image_shape') >= 0)){
        this.ChangeImgUrl = ASSET_URL + '/' + key;
        this.OnChangeImg = true;
      }
    },
    file(file) {
      if (file) {
        if (file.type.indexOf('image/') === -1) {
          alert('Please select an image file')
          return
        }
        this.$modal.show(this.modalName, {}, { title: 'ok' })

        this.resizeImage(file, this.maxImageDimension)
          .then(objectUrl => {
            if (this.imgObjectUrl) {
              URL.revokeObjectURL(this.imgObjectUrl)
            }
            this.imgObjectUrl = objectUrl
            this.imgData = objectUrl
            this.showCropper = true
            this.setLoadingForm(false)
            if (this.$refs.cropper) {
              this.$refs.cropper.replace(objectUrl)
            }
          })
          .catch(err => {
            console.error(err)
            this.setLoadingForm(false)
            alert('Unable to load this image, please try a different one')
          })
      }
    }
  },
  computed: {
    modalName() {
      return `cropper-${this.uniqueID(10)}`
    },
    localStorageName(){
      return this.context.name + '_' + this.product().id;
    }
  },
  beforeDestroy() {
    if (this.imgObjectUrl) {
      URL.revokeObjectURL(this.imgObjectUrl)
    }
  },
  methods: {
    ...mapGetters([
      'product',
      'platform',
      'getCartData',
      'isSaveLocalstorage'
    ]),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    setImage(e) {
      this.setLoadingForm(true)
      this.file = e.target.files[0]
      e.target.value = null
    },
    showFileChooser() {
      this.$refs.input.click()
    },
    hideModal(e) {
      e.preventDefault()
      this.$modal.hide(this.modalName)
    },
    // async onCrop() {
    //   this.loading = true
    //   this.cropData = this.$refs.cropper.getCroppedCanvas().toDataURL()
    //   var file = await this.upload(this.cropData).catch(err => {
    //     this.loading = true
    //     console.error(err)
    //   })
    //   this.file = null
    //   this.context.model = file
    //   this.$modal.hide(this.modalName)
    //   this.loading = false
    // },
    async onCrop() {

      this.setLoadingForm(true)
      const OnThis = this;
      const reader = new FileReader();
      reader.addEventListener("load", async () => {
        const up = await this.upload(reader.result)
        if(up.status){
          OnThis.setCartDataByKey({
            key: OnThis.localStorageName,
            name: OnThis.context.label,
            value: ASSET_URL + '/' + up.key
          });
        }
      }, false);
      reader.readAsDataURL(this.file);
      try{
        const UploadFile = await this.upload(this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg'))
        if(UploadFile.status){
          const file = {
            id: this.context.name,
            key: UploadFile.key
          }
          this.setIsSaveLocalstorage(true);
          this.context.model = file
          //this.context.model = this.$refs.cropper.getCroppedCanvas().toDataURL()
          this.$modal.hide(this.modalName)
          this.OnChangeImg = true
          this.ChangeImgUrl = ASSET_URL + '/' + UploadFile.key
        }
        this.setLoadingForm(false)
      }catch(err){
        this.setLoadingForm(false);
        this.setMessageError(true);
      }
    },
    handleCancel() {
      if (!(this.value && this.value.base64)) {
        this.file = null
      }
      this.showCropper = false
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    zoom(e) {
      if (e.detail.ratio > 1) {
        e.preventDefault()
      }
    },
    resizeImage(file, maxDimension) {
      return new Promise((resolve, reject) => {
        const sourceUrl = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
          const width = img.naturalWidth
          const height = img.naturalHeight
          const scale = Math.min(1, maxDimension / Math.max(width, height))
          const canvas = document.createElement('canvas')
          canvas.width = Math.max(1, Math.round(width * scale))
          canvas.height = Math.max(1, Math.round(height * scale))
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
          URL.revokeObjectURL(sourceUrl)
          const mime = file.type === 'image/png' ? 'image/png' : 'image/jpeg'
          canvas.toBlob(
            blob => {
              if (!blob) {
                reject(new Error('Canvas toBlob failed'))
                return
              }
              resolve(URL.createObjectURL(blob))
            },
            mime,
            0.92
          )
        }
        img.onerror = () => {
          URL.revokeObjectURL(sourceUrl)
          reject(new Error('Failed to load image'))
        }
        img.src = sourceUrl
      })
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      const put = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      if(put.status === 200){
        return {
          status: true,
          key: signedUrl.key
        }
      }else {
        return {
          status: false
        }
      }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>


<style>
.Modal_crop_box > div  {
  overflow: auto !important;
}
@media only screen and (max-width: 739px){
  .Modal_crop_box .vm--modal{
    top: 0px !important;
    height: 100vh !important;
    bottom: 0 !important;
    background: white !important;
    padding: 10px;
  }
}


.Modal_crop_box > div::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.Modal_crop_box > div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}


@media only screen and (max-width: 739px){
	.Abn-modal-close {
    z-index: 9999999;
    display: none !important
}

.Abn-modal-footer-div {
    display: flex;
}

.Abn-modal-footer-div > button {
    border-radius: 5px;
}
.Abn-modal-crop {
    margin-top: 20px !important;
}
}

</style>

<style scoped>
input[type='file'] {
  display: none;
}

.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}

img.custom-image {
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid var(--primary-color, #5c6ac4);
  cursor: pointer;
}
.copper-wrapper {
  display: grid;
  grid-template-columns: auto 120px;
}
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  /* grid-template-rows: auto 40px; */
}
.modal-wrapper .cropper-wrapper {
  overflow: hidden;
  margin-bottom: 10px;
}

.Abn-modal-crop{
  overflow: auto ;
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 2px;
  padding: 5px;
}


.Abn-modal-close {
  background: #6e6e6f;
  width: 50px;
  height: 50px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.modal-wrapper .cropper-wrapper::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.modal-wrapper .cropper-wrapper::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

.Modal_crop_box.vm--container > div > div{
  overflow: auto !important;
}


.Abn-modal-footer{
  display: flex;
  justify-content: space-between;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

.Abn-modal-footer {
    position: sticky;
    bottom: 0px;
    left: 0;
    right: 0;
    background: #ffffff;
}

.Abn-modal-footer-div{
  width: 600px;
  max-width: 100%;
  margin: auto;
  background: #ffffff;
  padding: 10px 0;
}

.Abn-modal-footer-div > button{
  margin: 0 2px;
}

.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}


.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}


.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.v-ion-abn{
  width: 30px;
  padding: 0;
  margin: 0;
}

button.btn.btn-upload-new {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  border: 1px solid #bdbbbb;
  line-height: 1;
  font-size: 14px;
  height: 80px;
}

.group-button-image {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.group-button-image > * {
  margin: 0 5px;
}


@media only screen and (max-width: 739px){
	.Abn-modal-footer {
    position: fixed !important;
    bottom: 0;
    left: 0;
    right: 0;
}
}

</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageCropper.vue